import { computed } from 'mobx';

export default class StationFtpModel {
  id;
  store;

  constructor(store, item) {
    this.store = store;
    this.id = +item.id;
    this.host = item.host;
    this.port = item.port;
    this.user = item.user;
    this.password = item.password;
    this.path = item.path;
    this.station_id = item.station_id;
    this.source = item.source;
    this.protocol = item.protocol;
  }

  @computed get asJson() {
    return {
      id: +this.id,
      host: this.host,
      port: this.port,
      user: this.user,
      password: this.password,
      path: this.path,
      station_id: this.station_id,
      source: this.source,
      protocol: this.protocol,
    };
  }

  updateFromJson(json) {
    this.id = +json.id;
    this.host = json.host;
    this.port = json.port;
    this.user = json.user;
    this.password = json.password;
    this.path = json.path;
    this.station_id = json.station_id;
    this.source = json.source;
    this.protocol = json.protocol;
  }
}



// WEBPACK FOOTER //
// ./src/models/StationFtpModel.js